import { BASE_URL } from '../configs/config';

export const getStadiumInfo = async (userId: string) => {
  try {
    const res = await fetch(`${BASE_URL}checkRestStadiumInfo?user_id=${userId}`, {
      method: 'GET',
      cache: 'no-cache',
    });
    const data = await res.json();
    return data;
  } catch (error) {}
};
